import dayjs from 'dayjs';

export const formatLockDateTime = (value?: string) => {
  if (!value) {
    return '—';
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD HH:mm:ss') : value;
};

export const formatDuration = (seconds?: number | null) => {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds)) {
    return '—';
  }
  const total = Math.max(0, Math.floor(seconds));
  const days = Math.floor(total / 86400);
  const hours = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secs = total % 60;
  const parts: string[] = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (minutes && parts.length < 3) parts.push(`${minutes}m`);
  if (!parts.length || (secs && parts.length < 3)) parts.push(`${secs}s`);
  return parts.join(' ');
};

export const formatAgeLabel = (seconds?: number | null) => {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds)) {
    return '—';
  }
  const total = Math.max(0, Math.floor(seconds));
  if (total >= 86400) {
    const days = Math.floor(total / 86400);
    return `${days}d ago`;
  }
  if (total >= 3600) {
    const hours = Math.floor(total / 3600);
    return `${hours}h ago`;
  }
  if (total >= 60) {
    const minutes = Math.floor(total / 60);
    return `${minutes}m ago`;
  }
  return `${total}s ago`;
};
